import { useMemo } from 'react';

import { useAuthentication } from '@ravago/shared/authentication';
import { LeadTimeIndicator } from '@ravago/shared/page-data/models/elements/product-lead-time.model';

import { hasMtsLocalLeadTime, LeadTimeCheckCriteria } from '../../../../../utils/lead-time';
import { LeadTimeMessage } from '../../../../shared/lead-time-message/lead-time-message';
import { OTHER_COLOR_ID, UNKNOWN_COLOR_ID } from '../../constants';
import { usePathCountryCode } from '@ravago/shared/page-elements-radiance/hooks/use-path-locale';

interface Props {
   colorId?: number | null;
   producerColorCode?: string | null;
   leadTimeIndicators: LeadTimeIndicator[];
   leadTimeEnabled: boolean;
}

export const RfqLeadTime = ({ colorId, producerColorCode, leadTimeIndicators, leadTimeEnabled }: Props) => {
   const { accessToken } = useAuthentication();
   const countryCode = usePathCountryCode();

   const rfqHasMtsLocal = useMemo(() => {
      if (!colorId || !leadTimeEnabled || leadTimeIndicators.length === 0) {
         return false;
      }

      const criteria: LeadTimeCheckCriteria = {
         colorId,
         producerColorCode: producerColorCode ?? undefined,
         countryCode
      };

      return hasMtsLocalLeadTime(leadTimeIndicators, criteria);
   }, [colorId, producerColorCode, countryCode, leadTimeEnabled, leadTimeIndicators]);

   const isValidColor = colorId && colorId !== UNKNOWN_COLOR_ID && (colorId !== OTHER_COLOR_ID ? !!producerColorCode : true);

   if (!leadTimeEnabled || !accessToken || !isValidColor) return null;

   return <LeadTimeMessage hasMtsLocal={rfqHasMtsLocal} />;
};
